import { ICountType } from "./counttype.interface";
import { IProduct } from "./product.interface";

export interface IStorage {
    concat(f: any)
    length: any;
    storageStructureID: number,
    parentID?: number,
    fTypeID?: number,
    locID?: number,
    name?: string,
    description?: string,
    path?: string,
    sortOrder?: number,
    created_at?: any,
    updated_at?: any,
    deleted_at?: any,
    checked: boolean;
    products?: IProduct[]
}

export class TreeItemNode {
    children: TreeItemNode[];
    item: string;
    code: string;
    path: string;
    isSelected: boolean;
    parentID: number;
    parentcode: string;
    active: boolean;
    storageStructureID: number;
    productCount?: number;
}

export class TreeItemFlatNode {
    storageStructureID: number;
    parentID: number;
    item: string;
    path: string;
    // Canonical "Root -> Child -> Leaf" path built from the tree itself.
    // Set when the storage picker returns a selection; prefer it over `path`,
    // which mirrors a cached DB column that is not consistent across writers.
    fullPath?: string;
    isSelected: boolean;
    isLoading = false;
    active = false;
    level: number;
    expandable: boolean;
    code: string;
    parentcode: string;
    children: TreeItemNode[];
    productCount?: number;
}